import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ModalData {
  id: string
  type: string
  props?: Record<string, any>
}

export interface ModalState {
  openModals: ModalData[]
}

const initialState: ModalState = {
  openModals: [],
}

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<ModalData>) => {
      state.openModals = state.openModals.filter(
        modal => modal.type !== action.payload.type,
      )

      state.openModals.push(action.payload)
    },
    closeModal: (state, action: PayloadAction<string>) => {
      state.openModals = state.openModals.filter(
        modal => modal.id !== action.payload,
      )
    },
    closeModalByType: (state, action: PayloadAction<string>) => {
      state.openModals = state.openModals.filter(
        modal => modal.type !== action.payload,
      )
    },
    closeAllModals: state => {
      state.openModals = []
    },
  },
})

export const { openModal, closeModal, closeModalByType, closeAllModals } =
  modalSlice.actions

export const selectOpenModals = (state: { modal: ModalState }) =>
  state.modal.openModals
export const selectModalByType =
  (type: string) => (state: { modal: ModalState }) =>
    state.modal.openModals.find(modal => modal.type === type)
export const selectModalById = (id: string) => (state: { modal: ModalState }) =>
  state.modal.openModals.find(modal => modal.id === id)

export default modalSlice.reducer
